// extracted by mini-css-extract-plugin
export default {"container":"BinaryInput_container__Ro21i","option":"BinaryInput_option__efu+A"};